module.exports = __webpack_public_path__ + "img/capsule-toy-blue.fb458626.png";